import React from "react";
import { Link } from "react-router-dom";
import { HUB_CARD_DESCRIPTIONS } from "../../constants/mentalPatternsHub.js";
import { HUB_CARD_ICONS } from "../../constants/mediaAssets.js";
import { GAD7_TITLE, GAD7_ROUTE, GAD7_MAX_SCORE } from "../../constants/gad7.js";
import MediaIcon from "../MediaIcon.js";
import { useMentalPatterns } from "./MentalPatternsContext.js";

const TrendBadge = ({ trend }) => {
  if (!trend?.label) return null;
  const dirClass = trend.direction ? `mp-trend--${trend.direction}` : "mp-trend--stable";
  return <span className={`mp-trend ${dirClass}`}>{trend.label}</span>;
};

/** Hub cards: GAD-7 only (Under Stress / Anger demoted for now). */
const MentalPatternsDashboardCards = () => {
  const { gad7Analysis, hubInsights } = useMentalPatterns();
  const { totalScore: gad7Score, severityLabel: gad7SeverityLabel, hasData: hasGad7Data } = gad7Analysis;
  const trends = hubInsights?.trends || {};

  return (
    <div className="mental-patterns__dashboard-wrap">
      <nav className="mental-patterns__dashboard" aria-label="Pattern report cards">
        <div className="mental-patterns__dashboard-col">
          {hasGad7Data ? (
            <Link
              to={GAD7_ROUTE}
              className="mental-patterns__dash-card mental-patterns__dash-card--gad7"
              aria-label={`${GAD7_TITLE}: ${gad7Score} out of ${GAD7_MAX_SCORE}, ${gad7SeverityLabel}`}
            >
              <MediaIcon
                iconKey={HUB_CARD_ICONS.gad7}
                className="media-icon mental-patterns__dash-card-icon mental-patterns__dash-card-icon--gad7"
                size={32}
              />
              <div className="mental-patterns__dash-card-main">
                <span className="mental-patterns__dash-card-title">{GAD7_TITLE}</span>
                <span className="mental-patterns__dash-card-score">{gad7Score}</span>
                <span className="mental-patterns__dash-card-sub">/ {GAD7_MAX_SCORE}</span>
                {gad7SeverityLabel ? (
                  <span className="mental-patterns__dash-card-status">{gad7SeverityLabel}</span>
                ) : null}
              </div>
              <div className="mental-patterns__dash-card-extra" aria-hidden="true" />
              <div className="mental-patterns__dash-card-footer">
                <TrendBadge trend={trends.gad7} />
              </div>
            </Link>
          ) : (
            <span
              className="mental-patterns__dash-card mental-patterns__dash-card--gad7 mental-patterns__dash-card--disabled"
              aria-disabled
            >
              <MediaIcon
                iconKey={HUB_CARD_ICONS.gad7}
                className="media-icon mental-patterns__dash-card-icon mental-patterns__dash-card-icon--gad7"
                size={32}
              />
              <span className="mental-patterns__dash-card-title">{GAD7_TITLE}</span>
              <span className="mental-patterns__dash-card-score mental-patterns__dash-card-score--muted">—</span>
              <span className="mental-patterns__dash-card-status">No data yet</span>
            </span>
          )}
          <p className="mental-patterns__dash-desc">{HUB_CARD_DESCRIPTIONS.gad7}</p>
        </div>
      </nav>
    </div>
  );
};

export default MentalPatternsDashboardCards;
